import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type IAdvancedRichText } from '../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IParagraphWidget } from './IParagraphWidget.ts';

const StyledParagraphWrapper = styled.div`
  margin-bottom: 6px;
`;

export type IParagraphWidgetComponentProps =
  IWidgetComponentProps<IParagraphWidget>;

export function ParagraphWidgetComponent(
  props: IParagraphWidgetComponentProps,
) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);
  const { t } = useTranslation();

  const text = useMemo(() => {
    // Se sono in preview e non ho testo o c'è il paragrafo vuoto (probabilmente di default)
    // allora mostro un paragrafo di default
    if (
      options.preview &&
      (!props.widget.body || props.widget.body[0]?.text === null)
    ) {
      return [
        {
          type: 'text',
          text: t('paragraph-widget.new-paragraph', 'Nuovo paragrafo'),
        },
      ] as IAdvancedRichText;
    }
    // Fuori dalla preview mostro sempre il contenuto del body (o un array vuoto)
    return props.widget.body ?? [];
  }, [options.preview, props.widget.body, t]);

  if (!visible) return null;

  return (
    <StyledParagraphWrapper>
      <ParagraphSizeText>
        <RichTextAdvancedRender hasCustomFont text={text} />
      </ParagraphSizeText>
    </StyledParagraphWrapper>
  );
}
